import { forwardRef } from 'react';
// eslint-disable-next-line no-restricted-imports
import { Input as ArcInput, InputProps } from 'arc';
import { useInputSizeForApplicationType } from '../common/hooks/use-input-size-for-application-type';

export const Input = forwardRef(function (
    props: InputProps & {
        readOnly?: boolean;
        required?: boolean;
        disabled?: boolean;
    },
    ref?: React.Ref<HTMLInputElement>
) {
    const { size: propsSize, ...otherProps } = props;
    const size = useInputSizeForApplicationType(propsSize);
    return <ArcInput ref={ref} size={size} {...otherProps} />;
});
